import ApiService from "@/common/api/api.service";

const FICHA_SAUDE_PADRAO = {
    planoDeSaude: "",
    numeroCarteirinha: "",
    diabetes: false,
    medicamentoContinuo: false,
    nomeMedicamento: "",
    motivoMedicamento: "",
    alergia: false,
    especificaoAlergia: "",
    intoleranciaLactose: false,
    intoleranciaGluten: false,
    refluxo: false,
    deficiencia: false,
    especificacaoDeficiencia: "",
    tiposDeficiencias: [],
    observacoes: "",
    contratoId: "",
};

const FichaSaudeService = {
    async buscarDados(matriculaId) {
        try {
            let { data } = await ApiService.get(`FichaSaude?matriculaId=${matriculaId}`)
            return {
                data: data || { ...FICHA_SAUDE_PADRAO }
            }
        } catch (error) {
            return {
                data: { ...FICHA_SAUDE_PADRAO }
            }
        }
    },
    async salvarFicha(fichaSaude) {
        let { data } = await ApiService.post(`FichaSaude`, fichaSaude)
        return data
    },
    async atualizarFicha(fichaSaude) {
        let { data } = await ApiService.put(`FichaSaude`, fichaSaude)
        return data
    }
}

export default FichaSaudeService;